export default __webpack_public_path__ + "static/media/recebido.0ddf1857.svg";